import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import { setProductTypes } from 'redux/reducers/commonReducer';
import { clearBasket } from 'redux/reducers/basketReducer';
import API from 'constants/api';
import errorChecker from './errorChecker';

export const getProducts = () => dispatch =>
  fetch(`${API.mainAPI}${API.PRODUCTS}`)
    .then(errorChecker)
    .then(data => {
      const types = {};
      Object.entries(data).forEach(([type, variants]) => {
        types[type] = Object.entries(variants).map(([id, vars]) => ({
          ...vars,
          id,
          type,
          orientation: Object.entries(vars.orientation).map(([key, label]) => ({ id: key, label })),
          sizes: Object.entries(vars.sizes).map(([key, label]) => ({ id: key, label })),
          types: Object.entries(vars.types).map(([key, label]) => ({ id: key, label })),
          orientations_obj: vars.orientation,
          sizes_obj: vars.sizes,
          types_obj: vars.types,
        }));
      });
      dispatch(setProductTypes(types));
    })
    .catch(console.log);

export const getProductPayStatus = id => dispatch =>
  fetch(`${API.mainAPI}/api/order/${id}/paid_status/`)
    .then(errorChecker)
    .then(data => {
      if (data.is_paid) {
        dispatch(clearBasket());
        localStorage.removeItem('order_id');
      }
    })
    .catch(console.log);
